<template>
  <div class="recharge_left capital_first">
    <p class="capital_p1">
      <span>策略详情</span>
    </p>
    <div class="entrust_wrapper clearfix">
      <p class="entrust_p1">
        {{name}}
        <span>{{order}}</span>
        <span>{{time}}</span>
      </p>
      <br>
      <p class="entrust_p2">
        账户管理费：{{manage}}元/{{text}}
        <span>已策略天数：{{day}}个{{text}}</span>
      </p>
      <ul class="entrust_ul">
        <li class="ntrust_ul_active">
          <router-link to="/myaccount/dealbuy">交易委托</router-link>
        </li>
        <li @click="showProfit">提取利润</li>
        <li @click="showAdd">追加策略</li>
        <li @click="showBondAdd">追加履约金</li>
        <li @click="showSettlement" style="margin-right: 30px;">申请结算</li>
      </ul>
      <p class="entrust_p3"></p>
      <div class="entrust_center clearfix">
        <div class="entrust_centerLeft">
          <h4>合约总资产(元)</h4>
          <p class="entrust_p4">{{total}}</p>
          <p class="entrust_p5">
            当前盈亏(元)
            <span>{{divided}}利益分配</span>
          </p>
          <p class="entrust_p6" :class="profit_loss >= 0 ? 'red' : 'green' ">
            {{profit_loss}}
            <span>{{ratio}}</span>
          </p>
        </div>
        <div class="entrust_centerRight">
          <p class="entrust_p7">
            <span>持仓市值<router-link to="/" class="red font12">[明细]</router-link></span>
            <span>持仓比例</span>
            <span>可用余额</span>
          </p>
          <p class="entrust_p7" style="margin: 30px 0 43px 0;font-weight: 600;">
            <span>{{market}}</span>
            <span>{{depot_ratio}}</span>
            <span>{{available}}</span>
          </p>
          <p class="entrust_p7" style="margin-bottom: 30px;">
            <span>总策略资金</span>
            <span>申请额度</span>
            <span>风险履约金</span>
          </p>
          <p class="entrust_p7" style="font-weight: 600;margin-bottom: 50px;">
            <span>{{capital_total}}</span>
            <span>{{apply_quota}}</span>
            <span>{{bond}}</span>
          </p>
        </div>
      </div>
      <p class="entrust_p8">
        <!-- 当前仓位：
        <span>0.00%</span>-->
      </p>
      <p class="entrust_p9">
        <span></span>
        <span></span>
        <span></span>
      </p>
      <p class="entrust_p10">
        <span>亏损平仓线：{{close}}</span>
        <span>亏损警戒线：{{warning}}</span>
      </p>
    </div>
    <p class="entrust_p11">
      <span>持仓详情</span>
    </p>
    <ul class="entrust_ul2">
      <li class="entrust_li1">
        <span>股票名称</span>
        <span>持有股数</span>
        <span>可卖股数</span>
        <span>成本价</span>
        <span>当前价</span>
        <span>当前市值</span>
        <span>浮动盈亏</span>
        <!-- <span>操作</span> -->
      </li>
      <li v-for="(item,index) in list" :key="index">
        <span>
          <small class="font_weigth">{{item.name}}</small>
          ({{item.code}})
        </span>
        <span>{{item.number}}</span>
        <span>{{item.surplus}}</span>
        <span>
          <small class="font_weigth">￥({{item.price}})</small>
        </span>
        <span>
          <small class="font_weigth up_green">￥{{item.newPrice}}</small>
        </span>
        <span>{{item.market}}</span>
        <span :class="item.profitPrice >= 0 ? 'red':'green'">
          {{item.profitPrice}}
          <small class="font_weigth">({{item.priceRatio}}%)</small>
        </span>
        <!-- <span>
          <small class="entrust_small">+</small>
          <small class="entrust_small">-</small>
        </span> -->
      </li>
    </ul>
    <!-- 弹窗-利润提取 -->
    <div class="show2Box moduleBox">
      <div class="show2">
        <div class="show2_title">
          <div>利润提取</div>
          <div @click="hiddenProfit">x</div>
        </div>
        <div class="show2_content">
          <div>策略账户余额：{{available}}元</div>
          <div>当前盈利：{{extractProfit}}元</div>
          <div>
            <img src="../assets/img/sell_get.png">
            <input v-model="extractMoney" type="number" placeholder="请输入提取金额">
          </div>
          <div>最高可提利润{{extractMax}}元</div>
        </div>
        <div class="show2_foot">
          <button @click="operationProfit">确认</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 追加策略 -->
    <div class="show3Box moduleBox">
      <div class="show3">
        <div class="show2_title">
          <div>追加策略</div>
          <div @click="hiddenAdd">x</div>
        </div>
        <div class="show2_content">
          <div>股票账户追加策略，您支付的追加金额必须为100的整数！</div>
          <div>当前余额：{{balance}}元</div>
          <div>
            <img src="../assets/img/sell_get.png">
            <input type="text" v-model="addMoney" placeholder="请输入追加金额">
          </div>
          <div>
            最低追加
            <span style="color: orange;">{{minAdd}}</span>元
          </div>
        </div>
        <div class="show2_foot">
          <button @click="operationAdd">确认</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 追加履约金 -->
    <div class="show4Box moduleBox">
      <div class="show4">
        <div class="show2_title">
          <div>追加履约金</div>
          <div @click="hiddenBondAdd">x</div>
        </div>
        <div class="show2_content">
          <div>股票账户追加履约金，您支付的追加金额必须为100的整数！</div>
          <div>当前余额：{{balance}}元</div>
          <div>
            <img src="../assets/img/sell_get.png">
            <input type="text" v-model="addBondMoney" placeholder="请输入追加金额">
          </div>
          <div>
            最低追加
            <span style="color: orange;">{{minBondAdd}}</span>元
          </div>
        </div>
        <div class="show2_foot">
          <button @click="operationBondAdd">确认</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 申请结算 -->
    <div class="show1Box moduleBox">
      <div class="show1">
        <div class="show1_title">
          <div>结算确认</div>
          <div @click="hiddenSettlement">x</div>
        </div>
        <div class="show1_content">
          <div>确认结算当前策略？</div>
        </div>
        <div class="show1_foot">
          <button @click="operationSettlement">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Entrust",
  data() {
    return {
      name: "",
      order: "",
      type: "", //策略类型  1天配 2月配
      time: "",
      total: "0.00",
      market: "0.00",
      depot_ratio: "",
      available: "0.00",
      profit_loss: "0.00",
      ratio: "0.00",
      warning: "0.00",
      close: "0.00",
      capital_total: "0.00",
      apply_quota: "0.00",
      bond: "0.00",
      divided: "0.00",
      manage: "0.00",
      day: "0.00",
      text: "交易日", //交易日 或者交易月
      list: [],
      extractProfit: "0.00", //利润提取 盈亏
      extractMax: "0.00", //最大提取金额
      extractMoney: "", //提取输入金额
      balance: "0.00", //余额
      minAdd: "0.00", //最低追加策略金额
      addMoney: "", //追加策略金额
      minBondAdd: "", //最低追保证金金额
      addBondMoney: "" //追加保证金 金额
    };
  },
  mounted: function() {
    this.getstrategyInfo();
    this.getHoldlist();
  },
  watch: {
    listAllData: {
      handler(n, o) {
        this.listAllData = n;
      },
    },
    deep: true
  },
  methods: {
    getstrategyInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            var info = res.data.data;
            that.name = info.name;
            that.order = info.order;
            that.type = info.type;
            that.time = info.time;
            that.total = info.total;
            that.market = info.market;
            that.depot_ratio = info.depot_ratio;
            that.available = info.available;
            that.profit_loss = info.profit_loss;
            that.ratio = info.ratio;
            that.warning = info.warning;
            that.close = info.close;
            that.capital_total = info.capital_total;
            that.apply_quota = info.apply_quota;
            that.bond = info.bond;
            that.divided = info.divided;
            that.manage = info.manage;
            that.day = info.day;
            if (that.type == 2) {
              that.text = "交易月";
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getHoldlist() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: sessionStorage.getItem("token"),
            cid: that.$route.query.cid
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            var shortArr = [];
            if (dataArr.length != 0) {
              $.each(dataArr, function(index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr,dataArr);
              clearInterval(window.timer1);
              window.timer1 = setInterval(function() {
                that.getNewPrice(shortArr,dataArr);
              }, 1000);
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //请求当前价 计算 盈亏  盈亏比例
    getNewPrice(shortArr,dataArr) {
      let that = this;
      $.ajax({
        url: "http://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function() {
          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            dataArr[i]["newPrice"] = elements[3]; //当前价
            var newPrice = parseFloat(elements[3]); //当前价
            var number = parseFloat(dataArr[i].number); //持有股数
            var costPrice = parseFloat(dataArr[i].price); //成本价
            var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
            var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
            var market = (newPrice * number).toFixed(2); //当前市值
            priceRatio = priceRatio.toFixed(2);
            dataArr[i]["profitPrice"] = profitPrice;
            dataArr[i]["priceRatio"] = priceRatio;
            dataArr[i]["market"] = market;
          }
          that.list = dataArr;
        }
      });
    },
    //利润提取 - 显示
    showProfit() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "profit_out",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.extractProfit = res.data.data.profit;
            that.extractMax = res.data.data.max;
            $(".show2Box").fadeIn(50);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //利润提取 - 隐藏
    hiddenProfit() {
      $(".show2Box").fadeOut(50);
    },
    //利润提取 - 操作
    operationProfit() {
      let that = this;
      if (that.extractMoney == "") {
        that.$message.error("请输入提取金额");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "profit_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.extractMoney
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        $(".show2Box").fadeOut(50);
      }
    },
    //追加超盘 - 显示
    showAdd() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_capital_info",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.balance = res.data.data.total;
            that.minAdd = res.data.data.min_increase;
            $(".show3Box").fadeIn(50);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //追加超盘 - 隐藏
    hiddenAdd() {
      $(".show3Box").fadeOut(50);
    },
    //追加超盘 - 操作
    operationAdd() {
      let that = this;
      if (that.addMoney == "") {
        that.$message.error("请输入追加金额");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_capital_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addMoney
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.getstrategyInfo();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        $(".show3Box").fadeOut(50);
      }
    },
    //追加履约金 - 显示
    showBondAdd() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_bond_info",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.balance = res.data.data.total;
            that.minBondAdd = res.data.data.min_bond;
            $(".show4Box").fadeIn(50);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //追加履约金 - 隐藏
    hiddenBondAdd() {
      $(".show4Box").fadeOut(50);
    },
    //追加履约金 - 操作
    operationBondAdd() {
      let that = this;
      if (that.addBondMoney == "") {
        that.$message.error("请输入追加金额");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_bond_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addBondMoney
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000
              });
              that.getstrategyInfo();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        $(".show4Box").fadeOut(50);
      }
    },
    //申请结算 - 显示
    showSettlement() {
      $(".show1Box").fadeIn(50);
    },
    //申请结算 - 隐藏
    hiddenSettlement() {
      $(".show1Box").fadeOut(50);
    },
    //申请结算 - 操作
    operationSettlement() {
      let that = this;
      $(".show1Box").fadeOut(50);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "settlement",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000
            });
            window.sessionStorage.setItem("accountType", 3);
            this.$store.state.accountType = 3;
            that.$router.push({
              path: "/myaccount/strategyhistory"
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    }
  },
  beforeDestroy() {
    clearInterval(window.timer1);
  }
};
</script>
<style scoped>
@import url("./../assets/css/entrust.css");
  .font12{
    font-size: 12px;
  }
</style>





// WEBPACK FOOTER //
// src/components/entrust.vue